import { render, staticRenderFns } from "./UpdateLoginPasswordForm.vue?vue&type=template&id=7baf430e&"
import script from "./UpdateLoginPasswordForm.vue?vue&type=script&lang=js&"
export * from "./UpdateLoginPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports